import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService } from '../../../services/logistic.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-pick-job-grp-batches-picker',
  templateUrl: './pick-job-grp-batches-picker.component.html',
  styleUrls: ['./pick-job-grp-batches-picker.component.css']
})
export class PickJobGrpBatchesPickerComponent implements OnInit {
    public selectedBgPickJobGroupBatchesPicker: string = 'JOBS';

    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public selectListStockPlaces: Item[] = [];

    public itemsListPickers: Item[] = [];

    constructor(private datatask: DataTaskService, private logistic: LogisticService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(2330))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadStockPlaces() {
        if (!this.setting) return;

        this.selectListStockPlaces = await this.datatask.Post(2181, { businessco_no: this.setting.businessco_no });
    }

    private async loadPickers() {
        if (!this.setting) return;

        this.itemsListPickers = await this.datatask.Post(2331, this.setting);
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'businessco_no':
                this.loadStockPlaces();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();
        this.loadStockPlaces();
        this.loadPickers();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    businessco_no: string;
    stockplace_id: string;
    my_nbr_of_picks_last_hour: string;
    my_nbr_of_picks_today: string;
    my_nbr_of_picks_yesterday: string;
}
